import * as types from './headerTypes';

const DEFAULT_STATE = {
  isUpdatingUser: false
}

export default (state = DEFAULT_STATE, action) => {
  switch(action.type) {
    case types.UPDATE_HEADER_USER_PROFILE_BEGIN:
      return {
        ...state,
        isUpdatingUser: true
      }
    case types.UPDATE_HEADER_USER_PROFILE_ERROR:
      return {
        ...state,
        isUpdatingUser: false
      }
    case types.UPDATE_HEADER_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isUpdatingUser: false
      }
    default:
      return state
  }
}